<template>
  <div class="ui fullscreen modal" ref="modal">
    <div class="header">{{ $t("bulk code request") }}</div>
    <i class="close icon" @click="$emit('close')"></i>
    <div class="scrolling content">
      <div class="ui visible info message">
        <div class="content">
          <div class="header">
            {{ $t("information") }}
          </div>
          <p>{{ $t("max record number") }}: {{ max_record_number }}</p>
        </div>
      </div>
      <div class="ui form">
        <table
          class="ui very compact celled striped selectable table"
          ref="table"
          width="100%"
        >
          <thead>
            <tr>
              <th>{{ $t("customer name") }}</th>
              <th>{{ $t("customer email address") }}</th>
              <th>{{ $t("bill or ticket number") }}</th>
              <th>{{ $t("product type") }}</th>
              <th>{{ $t("gpu type") }}</th>
              <th>{{ $t("brand") }}</th>
              <!-- <th>{{ $t("card or notebook serial number") }}</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(itm, idx) in dt" :key="idx">
              <td><input type="text" v-model="dt[idx][0]" /></td>
              <td
                v-bind:class="{
                  negative: cnt(dt[idx][1], 1) > 1,
                }"
              >
                <input type="text" v-model="dt[idx][1]" />
              </td>
              <td
                v-bind:class="{
                  negative: cnt(dt[idx][2], 2) > 1,
                }"
              >
                <input type="text" v-model="dt[idx][2]" />
              </td>
              <td
                v-bind:class="{
                  negative: !['ESCRITORIO', 'LAPTOP', 'TARJETA'].includes(
                    dt[idx][3].toUpperCase(),
                  ),
                }"
              >
                <input type="text" v-model="dt[idx][3]" />
              </td>
              <td
                v-bind:class="{
                  negative: !gpus.find(
                    (g) =>
                      g.name.toUpperCase() == String(dt[idx][4]).toUpperCase(),
                  ),
                }"
              >
                <input type="text" v-model="dt[idx][4]" />
              </td>
              <td
                v-bind:class="{
                  negative: !brands.find(
                    (g) =>
                      g.name.toUpperCase() == String(dt[idx][5]).toUpperCase(),
                  ),
                }"
              >
                <input type="text" v-model="dt[idx][5]" />
              </td>
              <!-- <td
                v-bind:class="{
                  negative: cnt(dt[idx][6], 6) > 1,
                }"
              >
                <input type="text" v-model="dt[idx][6]" />
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="actions">
      <div class="ui green button" @click="ok">
        <i class="check icon"></i>{{ $t("ok") }}
      </div>
      <div class="ui cancel red button">{{ $t("cancel") }}</div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";

export default {
  components: {},
  name: "",
  props: {},
  computed: {
    // form() {
    //   let vm = this;
    //   return window.jQuery(vm.$refs.form).form({
    //     fields: {
    //       store: ["empty"],
    //       web_witness: ["empty"],
    //       social_witness: ["empty"],
    //     },
    //   });
    // },
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    // enterprise_setup() {
    //   return enterprise_setup(this);
    // },
  },
  data() {
    return {
      dt: [],
      bundles: [],
      stores: [],
      gpus: [],
      brands: [],
      max_record_number: "",
    };
  },
  methods: {
    cnt(value, idx) {
      let vm = this;
      let rtrn = vm.dt.filter((i) => {
        return String(i[idx]).toUpperCase() == String(value).toUpperCase();
      });
      return rtrn.length;
    },
    // request() {
    //   let vm = this;
    //   let isFormValid = true;
    //   isFormValid = vm.form.form("validate form");
    //   if (isFormValid) {
    //     local_api(vm, "post", "/nvidia_ticket/store/do-request-bundle", {
    //       d: vm.d,
    //     })
    //       .then(function(r) {
    //         vm.$emit("request_created", r);
    //         window.jQuery(vm.$refs.modal).modal("hide");
    //       })
    //       .catch(function(err) {
    //         error_toast(err);
    //       });
    //   }
    // },
    hide() {
      let vm = this;
      window.jQuery(vm.$refs.modal).modal("hide");
      vm.dt = [];
    },
    show(rows, stores) {
      let vm = this;
      vm.stores = stores;
      let lngth = Number(rows.length);
      let max = Number(vm.max_record_number);

      // vm.dt = rows.slice(1, rows.length);
      vm.dt = rows.slice(1, max > lngth ? lngth : max + 1);
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {},
        })
        .modal("show");
    },
    ok() {
      let vm = this;

      /**
       * Search for some negative td meaning is some product type incorrect
       */
      let negativeTDs = window.jQuery(vm.$refs.table).find("td.negative");
      if (negativeTDs && negativeTDs.length > 0) {
        error_toast(
          vm.$t(
            "check for valid product types, not repeating emails, bill number, serial or gpu type market in red",
          ),
        );
      } else {
        local_api(this, "post", "/nworkforce_store/do-bulk-request", {
          data: vm.dt,
          b: vm.bundles,
          s: vm.stores.map((s) => {
            return s.store_id;
          }),
        })
          .then((rr) => {
            vm.$emit("finished", rr);
            success_toast(vm.$t("request created"));
            vm.hide();
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    setBundles(bundles) {
      this.bundles = bundles;
    },
    setGPUs(gpus) {
      this.gpus = gpus;
      // console.log("set gpus on excelmodal", gpus);
    },
    setBrands(brands) {
      // console.log("setting brands", brands);
      this.brands = brands;
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/nworkforce_store/do-get-configuration", {})
      .then((conf) => {
        let max_record_number =
          conf && conf.configuration && conf.configuration.max_record_number
            ? Number(conf.configuration.max_record_number)
            : 0;
        vm.max_record_number = max_record_number;
      })
      .catch((err) => {
        error_toast(err);
      });
  },
};
</script>

<style scoped>
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.is-capatilize {
  text-transform: capitalize !important;
}
/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
td.negative {
  background: #ffbebe !important;
}
td.negative:hover {
  background: #fe8080 !important;
}
</style>
